import { Link } from '@tanstack/react-router';
import { useSession } from '../../lib/auth/session.js';
import { useTenant } from '../../lib/api/hooks.js';
import { Icon } from '../ui/Icon.js';

/** A suspension for an overdue invoice gives its reason in these words (api subscriptions/overdue.ts). */
const OVERDUE_REASON = 'Overdue invoice';

/**
 * A suspended account, said where its people see it (docs/28 B3; doc 15 §8): why,
 * what still works, and for an overdue invoice where to pay it. Paying lifts the
 * suspension without anyone having to be asked.
 */
export function SuspendedNotice() {
  const tenantId = useSession((s) => s.activeTenantId);
  const can = useSession((s) => s.can);
  const tenant = useTenant(tenantId);
  const t = tenant.data;
  if (!t || t.status !== 'suspended') return null;
  const overdue = t.suspend_reason?.startsWith(OVERDUE_REASON) ?? false;

  return (
    <div className="arc-banner arc-banner-danger" style={{ marginBottom: 16 }} role="alert">
      <Icon name="warning" size={14} />
      <div>
        <div style={{ fontWeight: 600 }}>{t.name} is suspended</div>
        <div>
          {t.suspend_reason ? `${t.suspend_reason} ` : ''}
          Calls other than to emergency numbers are refused
          {overdue ? ' until the invoice is paid.' : '.'}
        </div>
        {overdue && can('invoice:read') && (
          <div style={{ marginTop: 6 }}>
            <Link to="/my/billing/$" params={{ _splat: 'invoices' }}>Pay the invoice</Link>
          </div>
        )}
      </div>
    </div>
  );
}
